import { Locale } from '@repo/utils'
import { Router } from 'next/router'
import React from 'react'

import { LanguageSwitchContext } from './language-switch.context'
import { LanguageSwitchModal } from './modal'

type LanguageSwitchProviderProps = {
  children: React.ReactNode
  onLocaleChange: (targetLocale: Locale) => Promise<void>
  resolveTranslatedPath: ({
    route,
    asPath,
    currentLocale,
    targetLocale,
  }: {
    route: Router['route']
    asPath: Router['asPath']
    currentLocale: Locale
    targetLocale: Locale
  }) => string | null
  pathname: string
  searchParams: string
}

export function LanguageSwitchProvider({
  children,
  onLocaleChange,
  resolveTranslatedPath,
  pathname,
  searchParams,
}: LanguageSwitchProviderProps) {
  const [isOpen, setIsOpen] = React.useState(false)

  const handleOpen = () => {
    setIsOpen(true)
  }

  const handleClose = () => {
    setIsOpen(false)
  }

  return (
    <LanguageSwitchContext.Provider
      value={{
        isOpen,
        handleClose,
        handleOpen,
        onLocaleChange,
        resolveTranslatedPath,
      }}
    >
      {children}

      <LanguageSwitchModal pathname={pathname} searchParams={searchParams} />
    </LanguageSwitchContext.Provider>
  )
}
